import { Injectable } from '@angular/core';

import {
  ANALYTICS_EVENT,
  CLICK_TYPE,
  DATA_ANALYTICS,
  MC_ANALYTICS
} from '../../enum/analytics.enum';
import {
  ClickAttributes,
  MCAnalyticsEvent,
  TripAttributes
} from '../../interface/analytics.interface';
import { TripsAnalyticsService } from '../services/analytics/trips-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsAdapter {
  constructor(private service: TripsAnalyticsService) {}

  formatMCAnalytics(
    eventData: MCAnalyticsEvent,
    tripType: string,
    formName: string
  ): void {
    const event_detail = this.buildEventDetail(eventData);
    const click = this.buildClickData(eventData, formName);
    const trips = this.buildMCTripsData(tripType, eventData.actionLabel);
    const event = ANALYTICS_EVENT.CLICK;
    this.service.setAdobeAnalytics({ event_detail, click, trips, event });
  }

  private buildEventDetail(eventData: MCAnalyticsEvent): string {
    return eventData.interactionType === CLICK_TYPE.LINK
      ? MC_ANALYTICS.EVENT_DETAIL +
          ':' +
          eventData.headerDesc +
          ':' +
          MC_ANALYTICS.LINK_NAME +
          ':' +
          DATA_ANALYTICS.LINK_CLICK
      : MC_ANALYTICS.EVENT_DETAIL +
          ':' +
          eventData.headerDesc +
          ':' +
          eventData.buttonLabel +
          ':' +
          DATA_ANALYTICS.CTA_CLICK;
  }

  private buildClickData(
    eventData: MCAnalyticsEvent,
    formName: string
  ): ClickAttributes {
    return {
      name:
        eventData.interactionType === CLICK_TYPE.LINK
          ? MC_ANALYTICS.LINK_NAME
          : eventData.buttonLabel,
      component_type: MC_ANALYTICS.COMPONENT_TYPE,
      component_name: MC_ANALYTICS.COMPONENT_NAME,
      type: eventData.interactionType,
      page_section: MC_ANALYTICS.PAGE_SECTION,
      action:
        eventData.interactionType === CLICK_TYPE.LINK
          ? MC_ANALYTICS.LANDING_HUB
          : eventData.buttonCode === MC_ANALYTICS.TRIPREQUIREMENTS
          ? MC_ANALYTICS.LANDING_HUB
          : formName
    };
  }

  private buildMCTripsData(
    tripType: string,
    messagingStatus: string
  ): TripAttributes {
    return {
      details: {
        trip_type: tripType,
        fly_ready_status: '',
        messaging_status: messagingStatus
      }
    };
  }
}
